<template>
    <section class="hero is-primary">
        <div class="hero-body">
            <div>
                <h1 class="title">
                    Operadores
                </h1>

                <b-field>
                    <b-input placeholder="buscar.."
                             type="search"
                             icon="magnify">
                    </b-input>
                    <p class="control">
                        <button class="button is-info">Buscar</button>
                    </p>
                </b-field>
                <b-table :data="data">
                    <template slot-scope="props">
                        <b-table-column label="id" muneric width="40">
                            {{props.row.id}}
                        </b-table-column>
                        <b-table-column label="Nombre">
                            {{props.row.name}}
                        </b-table-column>
                        <b-table-column label="email">
                            {{props.row.email}}
                        </b-table-column>
                        <b-table-column label="Rol">
                            {{props.row.rol}}
                        </b-table-column>
                        <b-table-column label="avatar">
                            {{props.row.avatar}}
                        </b-table-column>
                        <b-table-column label="Acciones">
                            <p class="buttons">
                                <a class="button is-success">
                                    <span class="icon is-small"><i class="fas fa-edit"></i></span>
                                </a>
                                <a class="button is-danger">
                                    <span class="icon is-small "><i class="fas fa-trash-alt"></i></span>
                                </a>
                            </p>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "List"
    }
</script>

<style scoped>

</style>
